import instance from "@/services/api";

export const sbsProjectAPI = {
  async getSbsProjectList(params) {
    return await instance()
      .get("/project/sbs_project/read_all/", { params })
      .then((res) => res?.data);
  },
  async getSbsProjectListSimple() {
    return await instance()
      .get("/project/sbs_project/read_list/")
      .then((res) => res?.data);
  },
};
